import { useLocation, Link } from "react-router-dom";
import BackgroundDecorations from '@/components/feature/BackgroundDecorations';
import ScrollReveal from '@/components/feature/ScrollReveal';
import { RailwayTiesPattern } from '@/components/feature/RailwayPatterns';

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative min-h-screen flex flex-col bg-background-50">
      <BackgroundDecorations variant="notFound" />
      
      <div className="flex-1 flex flex-col items-center justify-center text-center px-4 relative">
        <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
          404
        </h1>
        <div className="relative z-10">
          <div className="relative">
            <RailwayTiesPattern />
            <h1 className="relative z-[1] text-xl md:text-2xl font-semibold mt-6 text-foreground-900">页面未找到</h1>
            <p className="relative z-[1] mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
            <p className="relative z-[1] mt-4 text-lg md:text-xl text-foreground-500">该页面尚未生成，请返回首页</p>
            <Link
              to="/"
              className="relative z-[1] inline-flex items-center gap-2 mt-8 px-6 py-2.5 bg-primary-500 text-white rounded-md font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:-translate-y-0.5 whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-left-line" />
              </div>
              返回首页
            </Link>
          </div>
        </div>
      </div>

      <ScrollReveal>
        <footer className="relative bg-primary-800 text-foreground-50">
          <div
            className="absolute top-0 left-0 right-0 h-px"
            style={{
              background:
                'linear-gradient(to right, transparent, rgba(189,1,1,0.6), transparent)',
            }}
          />
          <div className="max-w-full px-4 md:px-8 py-7 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-white/40">
            <span>&copy; {new Date().getFullYear()} 华东交通大学 版权所有</span>
            <span>技术支持：华东交通大学信息化中心</span>
          </div>
        </footer>
      </ScrollReveal>
    </div>
  );
}